const PAGES = {
  dashboard: 'Dashboard',
  catalog: 'Catalog',
  details: 'Details',
  system_applications: 'Application Areas',
  cart: 'Cart',
  myaccount: 'My Account',
  checkout: 'Checkout',
  overview: 'Overview',
  qrscanner: 'QR Scanner',
  register: 'Register',
  password_forgot: 'Forgot password',
  password_reset: 'Password Change',
  products: 'Products',
  systems: 'Systems',
  news: 'News',
  checkout_type: 'Choosing Type',
  checkout_details: 'Details',
  checkout_summary: 'Summary',
  qcvmixer: 'QCV Mixer',
  elasticmixer: 'Flakes Mixer',
};

export default PAGES;
